import React from 'react'
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import AnalyticsManager from '../../../app/analytics';
import { getMediaPath } from '../../../app/functions';
import { AnalyticsParamValues } from '../../../constants/analytics';
import * as routes from '../../../constants/routes';
import { logout } from '../../../redux/actions';

// Assets
import headIcon from 'assets/icons/personal-details-white-background.svg';
import arrow from 'assets/icons/slider-arrow-blue.svg';
import personal_details from 'assets/icons/personal-menu-details.svg';
import personal_log_out from 'assets/icons/personal-log-out.svg';
import payment_methods from 'assets/icons/payment-methods.svg';
import address from 'assets/icons/address.svg';
import shoppingBag from 'assets/icons/shopping-bag.svg';
import './index.scss';

const PersonalMenu = (props) => {
    const user = props.userData;
    const text = props.text;
    const isDesktop = props.deviceState === 'desktop' || props.deviceState === 'desktop-large';

    const handleMyOrdersClick = () => AnalyticsManager.logPersonalZoneMenuItemPress(AnalyticsParamValues.MY_ORDERS);

    const handlePersonalDetailsClick = () => AnalyticsManager.logPersonalZoneMenuItemPress(AnalyticsParamValues.PERSONAL_DETAILS);

    const handleAddressClick = () => AnalyticsManager.logPersonalZoneMenuItemPress(AnalyticsParamValues.ADDRESS);

    const handlePaymentMethodsClick = () => AnalyticsManager.logPersonalZoneMenuItemPress(AnalyticsParamValues.PAYMENT_METHODS);

    const handleLogoutClick = () => {
        AnalyticsManager.logPersonalZoneMenuItemPress(AnalyticsParamValues.LOGOUT);
        AnalyticsManager.logLogout();

        props.logout();
        props.history.push(routes.home);
    };

    return (
        <section className="personal-menu">
            <div className="head">
                {!isDesktop &&
                    <div className="img-wrap">
                        <img src={getMediaPath(headIcon)} alt="/"/>
                    </div>
                }
                <span className="name">{' היי, ' + user['first_name']}</span>
            </div>

            <div className="tab-container">

                <NavLink
                    to={routes.personal_zone + routes.personal_zone_routes.my_orders}
                    className="tab-wrap"
                    activeClassName="selected"
                    onClick={handleMyOrdersClick}
                >
                    <img className="tab-icon" src={getMediaPath(shoppingBag)} alt="/"/>
                    <span className="tab-name">{text['personal_zone_orders']}</span>
                    <img className="arrow" src={getMediaPath(arrow)} alt="/"/>
                </NavLink>

                <NavLink
                    to={routes.personal_zone + routes.personal_zone_routes.personal_details}
                    className="tab-wrap"
                    activeClassName="selected"
                    onClick={handlePersonalDetailsClick}
                >
                    <img className="tab-icon" src={getMediaPath(personal_details)} alt="/"/>
                    <span className="tab-name">{text['personal_zone_details']}</span>
                    <img className="arrow" src={getMediaPath(arrow)} alt="/"/>
                </NavLink>

                <NavLink
                    to={routes.personal_zone + routes.personal_zone_routes.address}
                    className="tab-wrap"
                    activeClassName="selected"
                    onClick={handleAddressClick}
                >
                    <img className="tab-icon" src={getMediaPath(address)} alt="/"/>
                    <span className="tab-name">{text['personal_zone_address']}</span>
                    <img className="arrow" src={getMediaPath(arrow)} alt="/"/>
                </NavLink>

                <NavLink
                    to={routes.personal_zone + routes.personal_zone_routes.payment_methods}
                    className="tab-wrap"
                    activeClassName="selected"
                    onClick={handlePaymentMethodsClick}
                >
                    <img className="tab-icon payments" src={getMediaPath(payment_methods)} alt="/"/>
                    <span className="tab-name">{text['personal_zone_payment_methods']}</span>
                    <img className="arrow" src={getMediaPath(arrow)} alt="/"/>
                </NavLink>

                <div className="tab-wrap" onClick={handleLogoutClick}>
                    <img className="tab-icon" src={getMediaPath(personal_log_out)} alt="/"/>
                    <span className="tab-name">{text['personal_zone_logout']}</span>
                    <img className="arrow" src={getMediaPath(arrow)} alt="/"/>
                </div>
            </div>

        </section>
    );
};


//connect to redux store
const mapStateToProps = (store) => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        userData: store.config.UserData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(PersonalMenu));
